import { useEffect, useState } from 'react'
import { Navigate, useLocation, useSearchParams } from 'react-router-dom'
import { verifyAdminSession } from '@/api/adminApi'
import { isAdmin, markAdminSessionActive, setAdmin } from '@/utils/adminAuth'
import { setAuthNotice } from '@/utils/authFlow'
import { setTenantSlug } from '@/config/tenant'
import { useSessionExpiryWatch } from '@/hooks/useSessionExpiryWatch'

interface AdminRouteProps {
  children: React.ReactNode
}

export function AdminRoute({ children }: AdminRouteProps) {
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const [checking, setChecking] = useState(!isAdmin())
  const [valid, setValid] = useState(isAdmin())

  useSessionExpiryWatch()

  useEffect(() => {
    const tenantFromUrl = searchParams.get('tenant')?.trim().toLowerCase()
    if (tenantFromUrl) setTenantSlug(tenantFromUrl)

    if (isAdmin()) {
      setValid(true)
      setChecking(false)
      return
    }

    let cancelled = false
    verifyAdminSession()
      .then((data) => {
        if (cancelled) return
        const slug = data.tenantSlug || tenantFromUrl || ''
        if (slug) setTenantSlug(slug)
        setAdmin(null, data.email, { tenantSlug: slug })
        markAdminSessionActive()
        setValid(true)
      })
      .catch(() => {
        if (!cancelled) setValid(false)
      })
      .finally(() => {
        if (!cancelled) setChecking(false)
      })

    return () => {
      cancelled = true
    }
  }, [searchParams])

  if (checking) return null

  if (!valid) {
    setAuthNotice('admin', 'Sessão de administrador inválida ou expirada. Faça login novamente.')
    return <Navigate to="/admin" state={{ from: location }} replace />
  }

  return <>{children}</>
}
